export default __webpack_public_path__ + "static/media/Clan Bound Armbands of the Everlasting Sky.4b5cdf51.jpg";